import { axiosInstance } from '@/utils/api'
import { IClientLog } from '@/utils/types/systemTypes'

export async function postClientLog(payload: IClientLog) {
  const response = await axiosInstance.post('/system/client-log', payload)
  return response?.data
}
